import classNames from 'classnames'
import React from 'react'

// components
import GroupItemSegment, { GroupIconType } from 'src/components/item_segment/layouts/group/group'

// interfaces
import { GroupParticipationFragmentFragment, Maybe, GroupPreviewFragmentFragment } from '@lopo-tech/lopo-api'

// helpers
import { UrlUtils } from 'src/utils/url/url'

import './group_item.scss'
import {
  useGroupJoinConfirmation
} from 'src/containers/smart_components/group_member_list/hooks/useGroupJoinConfirmation'
import {
  useGroupLeaveConfirmation
} from 'src/containers/smart_components/group_member_list/hooks/useGroupLeaveConfirmation'
interface IGroupItemProps {
  group: GroupPreviewFragmentFragment;
  displayLastPostAt: boolean;
}

const getGroupIconType = (participation: Maybe<GroupParticipationFragmentFragment> | undefined): GroupIconType | undefined => {
  if (participation) {
    if (participation.role === 'ADMIN') return 'admin'
    if (!participation.confirmedAt) return 'pending'

    return undefined
  }

  return 'join'
}

const GroupItem: React.FC<IGroupItemProps> = ({ group }) => {
  const { onGroupJoin, ConfirmationModal } = useGroupJoinConfirmation()
  const { onGroupLeave, LeaveConfirmationModal } = useGroupLeaveConfirmation()

  const join = () => {
    if (!group.ownGroupParticipation) {
      onGroupJoin(group)
    }
  }

  const leave = () => {
    if (group.ownGroupParticipation) {
      onGroupLeave(group)
    }
  }

  return (
    <div className={classNames('group-item', { 'group-item--has-last-post': false })}>
      <GroupItemSegment
        isClosed={group.isClosed}
        label={group.name}
        description={group.description}
        groupIconType={getGroupIconType(group.ownGroupParticipation)}
        navigation={{ target: '_self', url: UrlUtils.groupPage(group.slug) }}
        canJoinGroup={group.canJoin.value}
        onJoin={join}
        onLeave={leave}
      />

      {ConfirmationModal && <ConfirmationModal />}
      {LeaveConfirmationModal && <LeaveConfirmationModal />}
    </div>
  )
}

export default GroupItem
